import { Directive,HostListener  } from '@angular/core';

@Directive({
    selector: '[pmNoSpace]'
})
export class NoSpaceDirective {

    constructor() { }
    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        // Prevent any space from being entered
        if (event.code === 'Space') {
            event.preventDefault();
        }
    }

    @HostListener('paste', ['$event'])
    onPaste(event: ClipboardEvent) {
        const clipboardData = event.clipboardData || window['clipboardData'];
        const pastedText = clipboardData.getData('text');

        // Prevent paste if it contains spaces
        if (pastedText.includes(' ')) {
            event.preventDefault();
        }
    }
}
